import React from 'react';
import styles from './NoValue.module.sass';

const NoValue = () =>
    <div className={styles.novalue}>
        -
    </div>;

export default React.memo(NoValue);